import type {
  WarehouseInventoryLayerItem,
  WarehouseInventoryMovementItem,
} from '../services/warehouseTypes'

const SHORT_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const

/** Normalize movement report_month ("Jul 2026" or "2026-07") to YYYY-MM. */
export function movementMonthKey(reportMonth: string | null | undefined): string | null {
  if (!reportMonth) return null
  const compact = reportMonth.replace(/\s+/g, ' ').trim()
  const iso = /^(\d{4})-(\d{2})$/.exec(compact)
  if (iso) return `${iso[1]}-${iso[2]}`

  const label = /^([A-Za-z]{3}) (\d{4})$/.exec(compact)
  if (label) {
    const idx = SHORT_MONTHS.findIndex((m) => m.toLowerCase() === label[1]!.toLowerCase())
    if (idx >= 0) return `${label[2]}-${String(idx + 1).padStart(2, '0')}`
  }
  return null
}

export function layerOrderMonthKey(orderDate: string | null | undefined): string | null {
  return txnDateMonthKey(orderDate)
}

/** Normalize ISO or parseable date to YYYY-MM (ledger txn_date, layer order_date, etc.). */
export function txnDateMonthKey(date: string | null | undefined): string | null {
  if (!date) return null
  const match = /^(\d{4}-\d{2})/.exec(date)
  if (match?.[1]) return match[1]
  const parsed = new Date(date)
  if (Number.isNaN(parsed.getTime())) return null
  return `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}`
}

export function filterInflowLayersForMonth(
  layers: WarehouseInventoryLayerItem[],
  processMonth: string
): WarehouseInventoryLayerItem[] {
  if (!processMonth) return []
  return layers.filter((layer) => layerOrderMonthKey(layer.order_date) === processMonth)
}

export function filterMovementsForMonth(
  movements: WarehouseInventoryMovementItem[],
  processMonth: string
): WarehouseInventoryMovementItem[] {
  if (!processMonth) return []
  return movements.filter((move) => movementMonthKey(move.report_month) === processMonth)
}
